import { render, staticRenderFns } from "./PersonalExamPaper.vue?vue&type=template&id=4fa7a1fd&scoped=true&"
import script from "./PersonalExamPaper.vue?vue&type=script&lang=js&"
export * from "./PersonalExamPaper.vue?vue&type=script&lang=js&"
import style0 from "./PersonalExamPaper.vue?vue&type=style&index=0&id=4fa7a1fd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa7a1fd",
  null
  
)

export default component.exports